export enum UserRolesEnum {
  ADMIN = "ADMIN",
  OPERATOR = "OPERATOR",
  LGSP = "LGSP",
  ANONYMOUS = "ANONYMOUS",
  THIRD_PARTY = "3RD_PARTY",
}
